'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;

var _jump = require('./jump');

var _jump2 = _interopRequireDefault(_jump);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageUrl = void 0;

function init() {
    _jump2.default.init();

    pageUrl = location.hash ? stripHash(location.href) : location.href;

    document.addEventListener('click', onClick);
}

function onClick(e) {
    if (!isInPageLink(e.target)) {
        return;
    }

    e.stopPropagation();
    e.preventDefault();

    var offset = 0;
    var options = {};

    _jump2.default.jump(e.target.hash, null, offset, options);
}

function isInPageLink(n) {
    if (!n.tagName) {
        return false;
    }

    return n.tagName.toLowerCase() === 'a' && n.hash.length > 0 && stripHash(n.href) === pageUrl && n.hash !== '#main-content';
}

function stripHash(url) {
    return url.slice(0, url.lastIndexOf('#'));
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/smoothscroll.js
// module id = ./resources/assets/js/src/ui/smoothscroll.js
// module chunks = 0